import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import './assets/js/flexble';
import ElementUI from 'element-ui';
import VueResource from 'vue-resource';
import './assets/font/font.css';
import animated from 'animate.css' // npm install animate.css --save安装，在引入
Vue.use(animated)
Vue.use(VueResource);
import global_ from './assets/js/api';
Vue.prototype.global = global_;
// Vue.prototype.$axios = axios;
import 'element-ui/lib/theme-chalk/index.css';
import './assets/iconfont/iconfont.css';//（这是我的文件路径，如果在不同的项目下需要注意）
import './assets/iconfont/iconfont.css';
Vue.config.productionTip = false
Vue.use(ElementUI);
import VueAMap from 'vue-amap';

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: 'your amap key',
  plugin: ['AMap.Autocomplete', 'AMap.PlaceSearch', 'AMap.Scale', 'AMap.OverView', 'AMap.ToolBar', 'AMap.MapType', 'AMap.PolyEditor', 'AMap.CircleEditor'],
  // 默认高德 sdk 版本为 1.4.4
  v: '1.4.4'
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
